//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    video: {
      type: Object,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  }
}

